const { get } = require('./retriever');
const VI_DWEB_PAGE_ID = '2047675';
/**
 *  strmgtweb nodejs app and its components uses data-track attribute for pulsar tracking.
 *  This method must be used for this component to distinguish tracking events from them.
* @param {object} data - tracking data object
* @returns tracking object to be used for pulsor event
*/
const getTracking = (data) => {
    if (!data) {
        return null;
    } else if (data.operationId === VI_DWEB_PAGE_ID) {
        return ({ 'data-vi-tracking': JSON.stringify(data) });
    }
    return ({ 'data-tracking-data': JSON.stringify(data) });
};

const dispatchTracking = (trackingData) => {
    if (trackingData) {
        document.dispatchEvent(new CustomEvent('pulsar', { detail: trackingData }));
    }
};

/**
 * dispatches pulsar event with the tracking details containing any props to be sent with eventProperty
 * @param {Object} event
 * @param {Object} props
 * @param {Object} trackingAttr
 */
const trackEvent = (event, props = {}, trackingAttr = null) => {
    // check for the event type
    const element = event?.originalEvent
        ? event?.originalEvent?.target?.closest('[data-tracking-data]')
        : event?.target?.closest('[data-tracking-data]');
    const trackingData = element?.dataset?.trackingData
        || trackingAttr?.['data-tracking-data'];
    if (trackingData) {
        const trackingObj = JSON.parse(trackingData);
        if (trackingObj) {
            // merge props into eventProperty
            trackingObj.eventProperty = { ...trackingObj.eventProperty, ...props };
            dispatchTracking(trackingObj);
        }
    }
};

/**
 * this method is used to get the tracking attribute which is tracked by
 * the host app using 'data-track' as the attribute name
 * @param {object} trackingObj
 * @returns
 */
const getLinkTracking = trackingObj => {
    if (!trackingObj) {
        return null;
    }
    if (trackingObj.actionKind === 'NAV') {
        return { '_sp': trackingObj.eventProperty?.sid };
    }
    return { 'data-track': JSON.stringify(trackingObj) };
};

/**
 * prefixes sid value of the passed config object
 * @param {Object} trackingConfig
 * @param {String} pageId
 * @returns {Object} updated config object
 */
const prefixPageId = (trackingConfig, pageId) => {
    if (!trackingConfig) {
        return null;
    }

    const partialSid = get(trackingConfig, 'eventProperty.sid', '');
    const sid = pageId
        ? `p${pageId}.${partialSid}`
        : partialSid;

    return (Object.assign({}, trackingConfig,
        {
            eventProperty: {
                sid
            }
        })
    );
};

module.exports = {
    getTracking,
    getLinkTracking,
    dispatchTracking,
    trackEvent,
    prefixPageId
};
